import { API_EDUCATION, API_NEWS, API_ORDER_CENTER, API_SELLER } from 'api/endpoints'
import {
  createRejectHandler,
  requestInterceptor,
} from 'api/helpers/handlers'
import {
  subdivisionInterceptor,
  subdivisionRejectHandler,
} from 'api/helpers/subdivision'
import axios from 'axios'

const RTO = 30000

const apiSeller = axios.create({
  baseURL: API_SELLER,
  responseType: 'json',
  timeout: RTO,
  headers: {
    'Accept-Language': 'ru',
  },
})

apiSeller.interceptors.request.use(requestInterceptor)
apiSeller.interceptors.request.use(subdivisionInterceptor)
apiSeller.interceptors.response.use((r) => r, createRejectHandler(apiSeller))
apiSeller.interceptors.response.use((r) => r, subdivisionRejectHandler)

const apiNews = axios.create({
  baseURL: API_NEWS,
  responseType: 'json',
  timeout: RTO,
})

apiNews.interceptors.request.use(requestInterceptor)
apiNews.interceptors.response.use((r) => r, createRejectHandler(apiNews))

const apiOrderCenter = axios.create({
  baseURL: API_ORDER_CENTER,
  responseType: 'json',
  timeout: RTO,
})

apiOrderCenter.interceptors.request.use(requestInterceptor)
apiOrderCenter.interceptors.response.use(
  (r) => r,
  createRejectHandler(apiOrderCenter),
)

const apiEducation = axios.create({
  baseURL: API_EDUCATION,
  responseType: 'json',
  timeout: RTO,
})

apiEducation.interceptors.request.use(requestInterceptor)
apiEducation.interceptors.response.use((r) => r, createRejectHandler(apiEducation))

export {
  apiEducation,
  apiNews,
  apiOrderCenter,
  apiSeller,
}
